import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import { listUsers } from '../../../api/users';
import UserTable from '../../../components/Users/UserTable';
import { useErrorHandler } from '../../../hooks/Error/useErrorHandler';
import { setLoading } from "../../../store/UI";
import { UserResponse } from '../../../types/model/user/UserResponse';
import { StoreInterfaces } from '../../../types/store/StoreInterfaces';

const AdminUsers: React.FC = () => {
  const handleError = useErrorHandler();
  const [users, setUsers] = useState<UserResponse[]>([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const session = useSelector((state: StoreInterfaces) => state.session);

  const fetchUsers = async () => {
    try {
      dispatch(setLoading(true));
      const data = await listUsers();
      setUsers(data);
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleRequestRefresh = () => {
    fetchUsers();
  };

  const handleUserRowClick = (user: UserResponse) => {
    if (session.isAdministrator) {
      navigate(`/admin/users/${user.accountId}/${user.id}`);
    }
  };

  return (
    <UserTable 
      tableData={users} 
      onRequestRefresh={handleRequestRefresh} 
      onRowClick={handleUserRowClick}
      showAddButton={true}
    />
  );
};

export default AdminUsers;